import { endpoint } from 'services/endpoint';
import { http, httpQ4US } from 'services/http';
import { TEmVatCorrectionsImportApi } from './types';

export const emVatCorrectionsImport: TEmVatCorrectionsImportApi = {
	loadList: (payload) =>
		httpQ4US.post(endpoint.emVatCorrectionsImport.LOAD, payload).then((response) => response.data),
	submitCorrectionAction: (payload) =>
		http.post(endpoint.emVatCorrectionsImport.ACTION, payload).then((response) => response.data),
	fetchSupportiveDocument: (payload) =>
		http
			.post(endpoint.emVatCorrectionsImport.FETCH_SUPPORTIVE_DOCUMENT, payload, {
				responseType: 'blob',
			})
			.then((response) => response.data),
};
